export const candidateModalsDefaultState = {};

const initialState = {};

const candidateModalsReducer = (state = initialState, { type }) => {
  switch (type) {
    default:
      return state;
  }
};

export default candidateModalsReducer;
